import React from 'react'
import { Box } from '@node-space/ui-components'
import { CardDetails } from './CardDetails'
import { CardTransactionsTable } from './CardTransactionsTable'

export const CustomerCard = () => {
  const handleFreeze = () => {}

  return (
    <Box flexCol gapY={24} width="full">
      <CardDetails onFreeze={handleFreeze} />
      <CardTransactionsTable />
    </Box>
  )
}
